
/**
 * 알림 전달 설정
 */
export type GetNotificationSettings200DeliverySettings = {
  /** 이메일 알림 활성화 여부 */
  email?: boolean;
  /** 푸시 알림 활성화 여부 */
  push?: boolean;
  /** SMS 알림 활성화 여부 */
  sms?: boolean;
};
